import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { LoginByEmailAndPassFirebaseRequestDTO } from '../http/dto/loginByEmailAndPassFirebaseRequestDTO';
import { LoginErrors } from '../http/dto/loginErrors';

const LoginWithEmail: React.FC<{
  isLoading: boolean;
  errors?: LoginErrors;
  isAnyOtherLoginOptionEnabled?: boolean;
  handleLoginByEmailAndPassword: (loginData: LoginByEmailAndPassFirebaseRequestDTO) => void;
  handleBackButtonClick: () => void;
}> = (props) => {
  const { t } = useTranslation();

  const enteredEmail = useRef<HTMLInputElement>(null);
  const enteredPassword = useRef<HTMLInputElement>(null);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData: LoginByEmailAndPassFirebaseRequestDTO = {
      email: enteredEmail.current?.value || '',
      password: enteredPassword.current?.value || '',
      returnSecureToken: true,
    };

    props.handleLoginByEmailAndPassword(formData);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
      <TextField
        disabled={props.isLoading}
        error={!!props.errors?.emailError}
        helperText={props.errors?.emailError && t(props.errors.emailError)}
        inputRef={enteredEmail}
        margin="normal"
        required
        fullWidth
        id="email"
        label={t('LOGIN.EMAIL__LABEL')}
        name="email"
        autoComplete="email"
      />
      <TextField
        disabled={props.isLoading}
        error={!!props.errors?.passwordError}
        helperText={props.errors?.passwordError && t(props.errors?.passwordError)}
        inputRef={enteredPassword}
        margin="normal"
        required
        fullWidth
        name="password"
        label={t('LOGIN.PASSWORD__LABEL')}
        type="password"
        id="password"
        autoComplete="current-password"
      />
      <Button disabled={props.isLoading} type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 3 }}>
        {props.isLoading && <CircularProgress size={20} sx={{ marginRight: '4px' }} />}
        {t('LOGIN.LOGIN_BUTTON__TEXT')}
      </Button>
      {props.isAnyOtherLoginOptionEnabled && (
        <Button onClick={props.handleBackButtonClick} disabled={props.isLoading} type="button" fullWidth variant="contained">
          {t('LOGIN.BACK_BUTTON__TEXT')}
        </Button>
      )}
    </Box>
  );
};

export default LoginWithEmail;
